import { render, staticRenderFns } from "./SupportHeader.vue?vue&type=template&id=68c34253&scoped=true"
import script from "./SupportHeader.vue?vue&type=script&lang=js"
export * from "./SupportHeader.vue?vue&type=script&lang=js"
import style0 from "./SupportHeader.vue?vue&type=style&index=0&id=68c34253&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c34253",
  null
  
)

export default component.exports